import {Component, EventEmitter, Input, OnDestroy, OnInit, Output, SimpleChange} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import {Law} from "../../../../../../models/laws";
import {Registration} from "../../../../../../models/registration";
import {RegistrationLaw} from "../../../../../../models/registration-law";
import {LawControllerService} from "../../../../../../services/laws-controller/law-controller.service";
import {LawService} from "../../../../../../services/laws-controller/law.service";
import {RegistrationLawControllerService} from "../../../../../../services/laws-controller/registration-law-controller.service";
import {Store} from "../../../../../../services/store.service";
import {BaseError} from "../../../../base-error";

@Component({
  selector: "law-list",
  templateUrl: "./law-list.component.html",
  providers: [],
  styles: [],
})
export class LawListComponent extends BaseError implements OnInit, OnDestroy {

  public registration: Registration;
  public serviceId: string;
  public registrationLawList: RegistrationLaw[] = [];
  public registrationLaw: RegistrationLaw;
  public law: Law;
  public laws: Law[];
  public topLayer = "list";
  public listToggle: boolean = false;
  public userFilter: any = {name: ""};
  public subscription: any;

  constructor(private lawControllerService: LawControllerService,
              private registrationLawControllerService: RegistrationLawControllerService,
              private lawService: LawService,
              public store: Store,
              public toastr: ToastrService) {
    super(toastr);
  }

  public ngOnInit() {
    this.subscription = this.lawService.change.subscribe((data) => {
      this.registration = data.registration;
      this.serviceId = data.serviceId;
      this.registrationLawList = data.registrationLawList;
      this.law = data.law;
      this.loadLaws();
    });
  }

  public ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  public loadLaws() {
    this.lawControllerService.getLawsList().subscribe(
      (data) => this.laws = data,
      (error) => this.showErrorMessageWithTitle("Error HTTP Post Service", error),
    );
  }

  public saveRegistrationLaw(law) {
    if (this.registration !== undefined) {

      this.law = law;
      this.registrationLaw = new RegistrationLaw();
      this.registrationLaw.law = this.law;

      this.registrationLawControllerService.createRegistrationLaw(this.registration.id, this.registrationLaw).subscribe(
        (data) => {
          this.lawService.updateData();
          this.responseSuccessful("Law added to registration");
        },
        (error) => this.showErrorMessageWithTitle("Error HTTP Post Service!", error),
      );
    }
  }

  public updateRegistrationLaw(registrationLaw) {
    this.registrationLawControllerService.saveRegistrationLaw(registrationLaw).subscribe(
      (data) => this.responseSuccessful("Law Registration updated"),
      (error) => this.showErrorMessageWithTitle("Error HTTP Post Service!", error),
    );
  }

  public deleteRegistrationLaw(law) {
    let registrationLaw;
    if (this.registrationLawList && this.registrationLawList.length > 0) {
       this.registrationLawList.forEach((thisLaw: any) => {
         if (thisLaw.law.id === law.id) {
           registrationLaw = thisLaw;
         }
       });
    }
    this.registrationLawControllerService.deleteRegistrationLaw(registrationLaw.id).subscribe(
      (data) => {
        this.lawService.updateData();
        this.responseSuccessful("Law removed from registration");
      },
    );
  }

  public deleteLaw(isConfirmed, law) {
    if (isConfirmed) {
      this.lawControllerService.deleteLaw(law.id).subscribe(
        (data) => {
          this.lawService.updateData();
          this.responseSuccessful("Law deleted");
        },
        (error) => this.showErrorMessage(error),
      );
    }
  }

  public openEdit(law: any) {
    if (law) {
      this.law = law;
      this.registrationLaw = new RegistrationLaw();
      if (this.registrationLawList && this.registrationLawList.length > 0) {
         this.registrationLawList.forEach((thisLaw: any) => {
           if (thisLaw.law.id === law.id) {
             this.registrationLaw = thisLaw;
           }
         });
      }
    } else {
      this.law = new Law();
    }
    this.topLayer = "edit";
  }

  public closeLayer() {
    this.store.state.common.sections.active = false;
    this.store.state.common.sections.type = undefined;
  }

  public submitEdit(event) {
    if (event.registrationLaw && event.registrationLaw.id) {
      this.updateRegistrationLaw(event.registrationLaw);
    }
    this.lawService.updateData();
    this.topLayer = "list";
  }

  public cancelEdit(event) {
    if (event.cancel) {
      this.topLayer = "list";
    }
  }

  public isActive(law) {
    let lawActive = false;
    if (this.registrationLawList && this.registrationLawList.length > 0) {
       this.registrationLawList.forEach((thisRegistrationLaw: any) => {
         if (thisRegistrationLaw.law.id === law.id) {
           lawActive = true;
         }
       });
    }
    return lawActive;
  }

  public setListView(b) {
    this.listToggle = b;
  }

}
